/**
 * Shared API utilities — relay base URL resolution, authenticated fetch.
 *
 * Centralizes the relay origin derivation that was previously copy-pasted
 * across useAuth, useAdminData, UserManagement, CredentialVault, and clientLog.
 */

/**
 * Resolve the relay server's origin (scheme + host + port) from env config.
 *
 * In production, VITE_RELAY_HTTP_URL is typically a relative path like "/relay/http",
 * so the origin falls back to the current window location. In dev, an absolute URL
 * like "http://localhost:8787/relay/http" is parsed to extract the origin.
 */
export function getRelayOrigin(): string {
  const env = (import.meta.env.VITE_RELAY_HTTP_URL as string | undefined)?.trim();
  if (env) {
    if (env.startsWith('http')) return new URL(env).origin;
    return window.location.origin;
  }
  if (import.meta.env.DEV) return 'http://localhost:8787';
  return window.location.origin;
}
